import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IRecomendacaoRodada, LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'app-recomendacoes',
    templateUrl: './recomendacoes.component.html',
    styleUrls: ['./recomendacoes.component.scss']
})
export class RecomendacoesComponent implements OnInit {
    idLicenca!: string;

    fullText = '';
    currentText = '';
    typedText = '';
    index = 0;

    constructor(
        private route: ActivatedRoute,
        private licencasService: LicencasService,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.authService.setTheme('light');
        this.idLicenca = this.route.snapshot.paramMap.get('idLicenca')!;
        this.getRecomendacao();
    }

    private getRecomendacao() {
        const sub = this.licencasService.getRecomendacoes(this.idLicenca).subscribe({
            next: (response) => {
                sub.unsubscribe();
                // this.transformarMarkdownEmHtml(response.resultados);
                this.transformarTextEmHtml(response.resultados);
                this.typeText();
            }
        });
    }

    private typeText() {
        if (this.index < this.fullText.length) {
            this.currentText += this.fullText[this.index];
            this.typedText = this.currentText;
            this.index++;
            setTimeout(() => this.typeText(), 10); // velocidade
        }
    }

    private transformarTextEmHtml(resultados: IRecomendacaoRodada[]){
        let fullText = '';

        resultados.forEach((resultado) => {
            const html = resultado.recomendacao
                .replaceAll('```', '')
                .replace('html', '')
                .replaceAll('\n', '');

            fullText += this.criarHeaderRodada(resultado);
            fullText += html;
        });

        this.fullText = fullText;
    }

    private transformarMarkdownEmHtml(resultados: IRecomendacaoRodada[]) {
        let fullText = '';

        resultados.forEach((resultado) => {
            const mdList = resultado.recomendacao
                .replaceAll('```', '')
                .replace('markdown', '')
                .split('\n')
                .filter((text) => text != '\n');

            const listaFormatada: string[] = [];

            mdList.forEach((md) => {
                listaFormatada.push(this.markedownToHtml(md));
            });

            fullText += this.criarHeaderRodada(resultado);
            fullText += listaFormatada.join('');
        });

        this.fullText = fullText;
        // this.currentText = this.fullText;
    }

    private criarHeaderRodada(resultado: IRecomendacaoRodada){
        return `<h1 class="texto-primario">${resultado.rodada.nome}</h1>`
    }

    private markedownToHtml(md: string) {
        const mdModificado = md
            .trim()
            .replace(/\*\*(.*?)\*\*/g, '<strong style="font-weight: 700">$1</strong>'); // substitui asterisco por negrito

        if (mdModificado.startsWith('|')) {
            return '<p class="texto-tabela monospace mb-0">' + mdModificado + '</p>';
        }

        if (mdModificado.startsWith('# ')) {
            return mdModificado.replace(/^# (.*)$/gm, '<h2 class="h2 mt-4">$1</h2>');
        }

        if (mdModificado.startsWith('## ')) {
            return mdModificado.replace(/^## (.*)$/gm, '<h3 class="h3 mt-4">$1</h3>');
        }

        if (mdModificado.startsWith('### ')) {
            return mdModificado.replace(/^### (.*)$/gm, '<h4 class="h4 mt-4">$1</h4>');
        }

        if (mdModificado.startsWith('#### ')) {
            return mdModificado.replace(/^#### (.*)$/gm, '<h5 class="h5 mt-4">$1</h5>');
        }

        if (mdModificado.startsWith('- ')) {
            return mdModificado.replace(/^- (.*)$/gm, '<ul class="mt-4"><li>$1</li></ul>');
        }

        if (mdModificado == '') return '';

        // quando não possuir nenhuma tag, for texto cru, deve retornar com quebra de linha
        return `<p>${mdModificado}</p>`;
    }
}
